import { createFileRoute, redirect } from "@tanstack/react-router";

import DoorExit from "@repo/icons/default/DoorExit";

import {
  EmptyStateDescription,
  EmptyStateIcon,
  EmptyStateRoot,
  EmptyStateTitle,
} from "@/components/ui/empty-state/empty-state";
import { HeaderRoot, HeaderTitle } from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { logout } from "@/lib/logout";
import type { RootRouteContext } from "@/routes/-root/-root-context";

import type { JSX } from "react";

const beforeLoad = async (context: RootRouteContext): Promise<void> => {
  await logout(context);

  redirect({ to: "/auth/landing", throw: true });
};

const LogoutPage = (): JSX.Element => {
  return (
    <>
      <HeaderRoot>
        <HeaderTitle title="Livance" align="center" />
      </HeaderRoot>
      <Page>
        <EmptyStateRoot>
          <EmptyStateIcon icon={DoorExit} />
          <EmptyStateTitle>Saindo do seu consultório</EmptyStateTitle>
          <EmptyStateDescription>
            Estamos efetuando o logout. Por favor aguarde.
          </EmptyStateDescription>
        </EmptyStateRoot>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/auth/logout")({
  component: LogoutPage,
  beforeLoad: async ({ context }) => {
    await beforeLoad(context);
  },
});
